<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box lite_popup_box_website_restore_select">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ $t('language.common.restoreNewLocation') }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="show = false"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <!-- 加载中 -->
                <div class="lite-website-loading" v-show="fullscreenLoading"></div>
                <!-- 网站备份还原的选择 -->
                <div class="website_clone">
                    <div class="website_from_to">
                        <!-- 来源 -->
                        <div class="clone_from_to" :class="boxFrom">
                            <!-- 头部 -->
                            <div class="clone_head">
                                <div class="clone_head_title">{{ $t('language.common.backups') }}</div>
                            </div>
                            <!-- 内容 -->
                            <div class="clone_body myscroll">
                                <!-- 网站列表 -->
                                <div class="website_item" v-for="website in websitesFrom" :key="website.id">
                                    <!-- 网站 -->
                                    <div class="website_item_box" @click="loadWebsiteChilds(website, 'from')">
                                        <div class="website_item_status" :class="{clone_tree_open:website.isOpen, clone_tree_close:!website.isOpen, clone_tree_loading:website.isLoadingChilds}"></div>
                                        <!-- 网站备份到云盘，这里应该是云盘图标和云盘名称 -->
                                        <!-- <div :class="'website_item_icon drive-icon-' + website.type"></div> -->
                                        <!-- <div class="website_item_name">{{ website.name + getNodePath(data.task.param.to) }}</div> -->
                                        <!-- 但是需求非要显示备份前的网站名称和网站图标 -->
                                        <div :class="'website_item_icon drive-icon-' + 'Website'"></div>
                                        <div class="website_item_name">{{ getDrive(data.task.fdid).name }}</div>
                                    </div>
                                    <!-- 网站子集合 -->
                                    <div class="website_item_childs" v-if="website.isOpen && website.childs && website.childs.length > 0">
                                        <!-- 站点或数据库 -->
                                        <div class="website_item_child" v-for="node in website.childs" :key="node.id" @click="selectNode('from',node)">
                                            <div class="website_item_status" :class="cloneLeftSelect==node.id ? 'clone_radio_select' : 'clone_radio_blank'"></div>
                                            <div class="website_item_icon" :class="'clone_'+node.type"></div>
                                            <div class="website_item_name">{{ node.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 间隔 -->
                        <div class="clone_split"></div>
                        <!-- 中间内容 -->
                        <div class="clone_center">
                            <!-- 头部 -->
                            <div class="clone_head">
                                <div class="center_left_right">
                                    <div class="center_left">
                                        <div class="clone_head_title">{{ $t('language.website.sourceServers') }}</div>
                                    </div>
                                    <div class="center_right">
                                        <div class="clone_head_title">{{ $t('language.website.targetServers') }}</div>
                                        <div class="clone_head_icon clone_delete" @click="cleanCloneSelect()"></div>
                                    </div>
                                </div>
                            </div>
                            <!-- 内容 -->
                            <div class="clone_body myscroll">
                                <div class="center_left_right">
                                    <div class="center_left">
                                        <div class="clone_select_item" v-for="(node, index) in cloneFromData">
                                            <div class="clone_select_item_icon" :class="'clone_'+node.type"></div>
                                            <div class="clone_select_item_name">{{ node.name }}</div>
                                            <div class="clone_select_item_delete" :title="getDrive(node.did).name"><div class="clone_delete" @click="deleteSelectItem(index)"></div></div>
                                        </div>
                                    </div>
                                    <div class="center_right">
                                        <div class="clone_select_item" v-for="(node, index) in cloneToData">
                                            <div class="clone_select_item_icon" :class="'clone_'+node.type"></div>
                                            <div class="clone_select_item_name">{{ node.name }}</div>
                                            <div class="clone_select_item_delete" :title="getDrive(node.did).name"><div class="clone_delete" @click="deleteSelectItem(index)"></div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 间隔 -->
                        <div class="clone_split"></div>
                        <!-- 目标 -->
                        <div class="clone_from_to" :class="boxTo">
                            <!-- 头部 -->
                            <div class="clone_head">
                                <div class="clone_head_title">{{ $t('language.common.restoreTo') }}</div>
                                <div class="clone_head_icon add_website" @click="readyAddWebsite()"></div>
                            </div>
                            <!-- 内容 -->
                            <div class="clone_body myscroll">
                                <!-- 网站列表 -->
                                <div class="website_item" v-for="website in websites" :key="website.id">
                                    <!-- 网站 -->
                                    <div class="website_item_box" @click="loadWebsiteChilds(website, 'to')">
                                        <div class="website_item_status" :class="{clone_tree_open:website.isOpen2, clone_tree_close:!website.isOpen2, clone_tree_loading:website.isLoadingChilds}"></div>
                                        <div class="website_item_icon clone_website"></div>
                                        <div class="website_item_name">{{ website.name }}</div>
                                    </div>
                                    <!-- 网站子集合 -->
                                    <div class="website_item_childs" v-if="website.isOpen2 && website.childs && website.childs.length > 0">
                                        <!-- 站点或数据库 -->
                                        <div class="website_item_child" v-for="node in website.childs" :key="node.id" @click="selectNode('to',node)">
                                            <div class="website_item_status" :class="cloneRightSelect==node.id ? 'clone_radio_select' : 'clone_radio_blank'"></div>
                                            <div class="website_item_icon" :class="'clone_'+node.type"></div>
                                            <div class="website_item_name">{{ node.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button @click="selectDone">{{$t('language.common.ok')}}</button>
            </div>
        </div>
        <!-- 添加网站 -->
        <liteAddDrive :auth="auth" @submit="addWebsite()" />
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { Message } from "element-ui";
import requestUtils from '@/js/request_util.js';
import commonUtils from "@/js/workspace/common_util.js";
import liteAddDrive from "@/components/workspace/lite_add_drive";

export default {
    name: "liteWebsiteRestoreSelect",
    components: {
        liteAddDrive,
    },
    props: {
        data: Object,
        versionFiles: Array,
    },
    data() {
        return {
            // 是否显示弹窗
            show: false,
            // 全屏加载
            fullscreenLoading: false,
            // 已备份的数据库或站点（已备份文件里面分析出来的）
            dbSites: [],
            // 原数据库或站点（源网站云盘里面分析出来的）
            originDbSites: [],
            // 还原源
            cloneFromData: [],
            // 还原目标
            cloneToData: [],
            // 未选来源或目标的动画效果
            boxFrom: '',
            boxTo: '',
            // 添加网站参数准备
            auth: {
                show: false,
                loading: false,
                type: "",
                name: "",
                website: {
                    sites: [],
                    dbs: [],
                },
            },
            // 还原左右当前选择项
            cloneLeftSelect: '',
            cloneRightSelect: '',
        }
    },
    computed: {
        // 只显示网站
        websites() {
            if (!this.data.task) {
                return [];
            }
            const fdid = this.data.task.fdid;
            return this.$store.state.drives.filter(drive => {
                    return drive.type=='Website';
                });
        },
        // 只显示源网站
        websitesFrom() {
            if (!this.data.task) {
                return [];
            }
            const tdid = this.data.task.tdid;
            return this.$store.state.drives.filter(drive => {
                    return drive.id==tdid;
                });
        },
    },
    methods: {
        // 获取节点路径
        getNodePath(node) {
            let path = '';
            let arr = this.getNodeArr(node);
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                path += '/' + item.name;
            }
            return path;
        },
        // 获取节点和父
        getNodeArr(node) {
            let arr = [];
            while (node) {
                arr.push(node);
                node = node.parent;
            }
            return arr.reverse();
        },
        // 加载源数据库或网站
        loadSourceDbSites() {
            this.originDbSites = [];
            this.sendRequest("/file/list", { id: this.data.task.fdid, param: { node: null, start: null } }, (res) => {
                let nodes = res.nodes;
                for (var i=0; i<nodes.length; i++) {
                    let node = nodes[i];
                    this.originDbSites.push({ name: node.name.replace(/:/g, '_'), type: node.type })
                }
            });
        },
        // 加载已备份文件
        loadVersionInfo() {
            this.dbSites = [];
            const prefix = this.getNodePath(this.data.task.param.to);
            const start = prefix.length + 1;
            for (var i = 0; i < this.versionFiles.length; i++) {
                const pathSub = this.versionFiles[i].path.substring(start);
                const name = pathSub.substring(0, pathSub.indexOf('/'));
                if (this.dbSites.indexOf(name) == -1) {
                    this.dbSites.push(name);
                }
            }
        },
        // 删除已选择的项
        deleteSelectItem(index) {
            if (this.cloneFromData.length-1 >= index) {
                this.cloneFromData.splice(index, 1);
            }
            if (this.cloneToData.length-1 >= index) {
                this.cloneToData.splice(index, 1);
            }
            if (this.cloneFromData.length == this.cloneToData.length) {
                this.cloneLeftSelect = '';
                this.cloneRightSelect = '';
            }
        },
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                let drive = this.$store.state.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        init() {
            this.cleanCloneSelect();
            this.loadVersionInfo();
            this.loadSourceDbSites();
            for(var i=0;i<this.websitesFrom.length;i++) {
                Vue.set(this.websitesFrom[i], 'isOpen', false);
                Vue.set(this.websitesFrom[i], 'isOpen2', false);
                Vue.set(this.websitesFrom[i], 'isLoadingChilds', false);
                Vue.set(this.websitesFrom[i], 'childs', undefined);
            }
            for(var i=0;i<this.websites.length;i++) {
                Vue.set(this.websites[i], 'isOpen', false);
                Vue.set(this.websites[i], 'isOpen2', false);
                Vue.set(this.websites[i], 'isLoadingChilds', false);
                Vue.set(this.websites[i], 'childs', undefined);
            }
        },
        // 清理克隆已选择节点
        cleanCloneSelect() {
            this.cloneFromData = [];
            this.cloneToData = [];
            this.cloneLeftSelect = '';
            this.cloneRightSelect = '';
        },
        // 加载云盘
        loadDrives(callback) {
            this.sendRequest("/drive/list", {}, (data) => {
                const drives = this.$store.state.drives || [];
                data.forEach(newItem => {
                    const oldItem = drives.find(d => d.id === newItem.id);
                    if (oldItem) {
                        Object.assign(oldItem, newItem);
                    } else {
                        drives.push(newItem);
                    }
                });
                if (callback) {
                    callback();
                }
            })
        },
        // 确定添加网站
        addWebsite() {
            if (this.auth.loading) return;
            this.auth.loading = true;
            this.sendRequest("/drive/auth", this.auth, (data) => {
                this.auth.loading = false;
                this.auth.show = false;
                this.loadDrives(() => {
                    this.$store.state.needLoadDriveInfo = true;
                });
            }, () => {
                this.auth.loading = false;
            });
        },
        // 准备添加网站
        readyAddWebsite() {
            this.auth.type = "Website";
            this.auth.name = this.addCloudNameInit("Website");
            this.auth.loading = false;
            this.auth.show = true;
        },
        // 添加云盘名称初始化
        addCloudNameInit(name) {
            let names = [];
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                names.push(this.$store.state.drives[i].name);
            }
            // 返回一个不重复的名称，如果有同名就添加数字
            let count = 1;
            let temp = name;
            while (names.indexOf(temp) != -1) {
                temp = name + " " + count;
                count++;
            }
            return temp;
        },
        // 克隆选择节点
        selectNode(type, node) {
            const fromCount = this.cloneFromData.length;
            const toCount = this.cloneToData.length;
            if (type == 'from') {
                // 选择源
                if (fromCount < toCount) {
                    if (!this.checkSameDrive(this.cloneToData, node)) {
                        if ((this.cloneToData[toCount-1].type=='site' && node.type=='folder') || this.checkMatchType(this.cloneToData, node)) {
                            if (!this.checkNodeAdded(this.cloneFromData, node, this.cloneToData)) {
                                this.cloneFromData.push(node);
                                this.cloneLeftSelect = '';
                                this.cloneRightSelect = '';
                            }
                        }
                    }
                } else if (fromCount == toCount) {
                    if (!this.checkNodeAdded(this.cloneFromData, node, this.cloneToData)) {
                        this.cloneFromData.push(node);
                        this.cloneLeftSelect = node.id;
                    }
                } else if (fromCount > toCount) {
                    if (this.cloneFromData[fromCount-1] != node) {
                        if (!this.checkNodeAdded(this.cloneFromData, node, this.cloneToData)) {
                            this.cloneFromData.pop();
                            this.cloneFromData.push(node);
                            this.cloneLeftSelect = node.id;
                        }
                    }
                }
            } else if (type == 'to') {
                // 选择目标
                if (toCount < fromCount) {
                    if (!this.checkSameDrive(this.cloneFromData, node)) {
                        if ((this.cloneFromData[fromCount-1].type=='folder' && node.type=='site') || this.checkMatchType(this.cloneFromData, node)) {
                            if (!this.checkNodeAdded(this.cloneToData, node, this.cloneFromData)) {
                                this.cloneToData.push(node);
                                this.cloneLeftSelect = '';
                                this.cloneRightSelect = '';
                            }
                        }
                    }
                } else if (toCount == fromCount) {
                    if (!this.checkNodeAdded(this.cloneToData, node, this.cloneFromData)) {
                        this.cloneToData.push(node);
                        this.cloneRightSelect = node.id;
                    }
                } else if (toCount > fromCount) {
                    if (this.cloneToData[toCount-1] != node) {
                        if (!this.checkNodeAdded(this.cloneToData, node, this.cloneFromData)) {
                            this.cloneToData.pop();
                            this.cloneToData.push(node);
                            this.cloneRightSelect = node.id;
                        }
                    }
                }
            }
        },
        // 克隆选择，禁止同云盘克隆
        checkSameDrive(nodes, node) {
            const same = nodes[nodes.length-1].did == node.did;
            if (same) {
                Message.warning("The source and destination of the clone cannot be the same node.");
            }
            return same;
        },
        // 克隆选择，源和目标类型需要匹配
        checkMatchType(nodes, node) {
            const match = nodes[nodes.length-1].type == node.type;
            if (!match) {
                Message.warning("The source and destination types for the clone do not match.");
            }
            return match;
        },
        // 克隆选择，禁止重复选择
        checkNodeAdded(nodes, node, otherNodes) {
            if (nodes.length + 1 == otherNodes.length) {
                var arr = [];
                for (var i=0; i<nodes.length; i++) {
                    if (nodes[i].id == node.id) {
                        arr.push(otherNodes[i]);
                    }
                }
                var otherId = otherNodes[otherNodes.length-1].id;
                for (var i=0; i<arr.length; i++) {
                    if (arr[i].id == otherId) {
                        Message.warning("This node has been added.");
                        return true;
                    }
                }
            }
            return false;
        },
        // 克隆，加载网站下面的站点和数据库
        loadWebsiteChilds(drive, type) {
            if (!drive.isLoadingChilds) {
                if (drive.childs == undefined) {
                    let paramNode = null;
                    if (type == 'from') {
                        paramNode = this.data.task.param.to;
                    }
                    // 第一次加载
                    Vue.set(drive, 'isLoadingChilds', true);
                    this.sendRequest("/file/list", { id: drive.id, param: { node: paramNode, start: null } }, (data) => {
                        data.nodes.forEach(node => {
                            node.did = drive.id;
                            node.parent = paramNode;
                            // 之前备份过的，重新把类型确定回来
                            if (node.dir) {
                                for (let i = 0; i < this.originDbSites.length; i++) {
                                    if (this.originDbSites[i].name == node.name) {
                                        node.type = this.originDbSites[i].type;
                                        break;
                                    }
                                }
                            }
                        });
                        if (type == 'from') {
                            // 只展示之前备份过的
                            let filterData = [];
                            for(var i=0;i<data.nodes.length;i++) {
                                if (this.dbSites.indexOf(data.nodes[i].name) != -1) {
                                    filterData.push(data.nodes[i]);
                                }
                            }
                            // 站点排在数据库前面，然后名称升序
                            filterData.sort(function (a, b) {
                                let typeRes = a.type.localeCompare(b.type);
                                if (typeRes == 0) {
                                    return a.name.localeCompare(b.name);
                                } else {
                                    return -typeRes;
                                }
                            });
                            Vue.set(drive, 'childs', filterData);
                        } else {
                            Vue.set(drive, 'childs', data.nodes);
                        }
                        if (type == 'from') {
                            Vue.set(drive, 'isOpen', true);
                        }
                        if (type == 'to') {
                            Vue.set(drive, 'isOpen2', true);
                        }
                        Vue.set(drive, 'isLoadingChilds', false);
                    }, () => {
                        Vue.set(drive, 'isLoadingChilds', false);
                    });
                } else {
                    // 已经加载，展开或折叠
                    if (type == 'from') {
                        if (drive.isOpen) {
                            Vue.set(drive, 'isOpen', false);
                        } else {
                            Vue.set(drive, 'isOpen', true);
                        }
                    }
                    if (type == 'to') {
                        if (drive.isOpen2) {
                            Vue.set(drive, 'isOpen2', false);
                        } else {
                            Vue.set(drive, 'isOpen2', true);
                        }
                    }
                }
            }
        },
        // 选择完成
        selectDone() {
            const fromCount = this.cloneFromData.length;
            const toCount = this.cloneToData.length;
            // 检测是否选择源
            if (fromCount==0 || fromCount<toCount) {
                this.boxFrom = "box-shake";
                setTimeout(() => {
                    this.boxFrom = "box-shakeOrigin";
                }, 100);
                return;
            }
            // 检测是否选择目标
            if (toCount==0 || toCount<fromCount) {
                this.boxTo = "box-shake";
                setTimeout(() => {
                    this.boxTo = "box-shakeOrigin";
                }, 100);
                return;
            }
            // 源和目标数据
            let fromDatas = [];
            let toDatas = [];
            this.cloneFromData.forEach(node => {
                fromDatas.push({did:node.did, node:node});
            });
            this.cloneToData.forEach(node => {
                toDatas.push({did:node.did, node:node});
            });
            this.show = false
            this.$emit('ok', fromDatas, toDatas);
        },
        // 不显示加载中的请求
        noLoading(path) {
            return ["/file/list"].includes(path);
        },
        // 发送Lite请求
        sendRequest(path, data, callback, errorCallback) {
            if (!this.noLoading(path)) {
                this.fullscreenLoading = true;
            }
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    if (!this.noLoading(path)) {
                        this.fullscreenLoading = false;
                    }
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data)
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg)
                        if (errorCallback) {
                            errorCallback(res)
                        }
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            if (path != "/drive/info") {
                                Message.error(msg)
                            }
                            if (errorCallback) {
                                errorCallback(res)
                            }
                        }
                    }
                }, err => {
                    if (!this.noLoading(path)) {
                        this.fullscreenLoading = false;
                    }
                    // 请求异常
                    Message.error(err)
                    if (errorCallback) {
                        errorCallback(err)
                    }
                });
        }
    }
}
</script>

<style scoped>
/* 弹窗宽度 */
.lite_popup_box.lite_popup_box_website_restore_select {
    width: 1300px;
}
/* 网站克隆 */
.website_clone {
    height: 500px;
}
/* 主体内容 */
.website_from_to {
    height: 100%;
    display: flex;
    flex-direction: row;
}
/* 克隆来源目标 */
.clone_from_to {
    flex: 1;
    border: 8px solid #E2EBFD;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    transition: transform 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* 克隆间隔 */
.clone_split {
    width: 20px;
}
/* 克隆中间内容 */
.clone_center {
    flex: 2;
    border: 8px solid #E2EBFD;
    background: #FFFFFF;
}
/* 头部 */
.clone_head {
    height: 38px;
    background: #F2F7FE;
}
/* 内容 */
.clone_body {
    flex-grow: 1;
    padding: 10px 0;
    overflow: auto;
    user-select: none;
}
.clone_center>.clone_body {
    height: calc(100% - 58px);
}
/* 头部标题 */
.clone_head_title {
    color: #C1CBE3;
    font-size: 18px;
    font-weight: bold;
    margin: 10px 16px;
    display: inline-block;
}
/* 头部图标 */
.clone_head_icon {
    width: 20px;
    height: 20px;
    float: right;
    margin-top: 9px;
    margin-right: 16px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
}
.clone_center .clone_head_icon {
    float: none;
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
}
/* 添加网站 */
.add_website {
    background-image: url("../../assets/images/lite/icon/add_website.svg");
}
/* 删除图标 */
.clone_delete {
    background-image: url("../../assets/images/lite/icon/delete.svg");
}
/* 网站 */
.clone_website {
    background-image: url("../../assets/images/lite/icon/website.svg");
}
/* 站点 */
.clone_site {
    background-image: url("../../assets/images/lite/icon/site.svg");
}
/* 数据库 */
.clone_db {
    background-image: url("../../assets/images/lite/icon/db.svg");
}
/* 文件夹 */
.clone_folder {
    background-image: url("../../assets/images/lite/icon/folder.svg");
}
/* 单选框-已选择 */
.clone_radio_select {
    background-image: url("../../assets/images/lite/icon/radio_select.svg");
}
/* 单选框-空白 */
.clone_radio_blank {
    background-image: url("../../assets/images/lite/icon/radio_blank.svg");
}
/* 树-关闭 */
.clone_tree_close {
    background-image: url("../../assets/images/lite/icon/tree_close.svg");
}
/* 树-打开 */
.clone_tree_open {
    background-image: url("../../assets/images/lite/icon/tree_open.svg");
}
/* 树-加载 */
.clone_tree_loading {
    background-image: url("../../assets/images/lite/icon/tree_loading.svg");
    animation: rotateLoading 1s linear infinite;
}
@keyframes rotateLoading {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* 中间左右布局 */
.center_left_right {
    display: flex;
    flex-direction: row;
    height: 100%;
}
/* 左边 */
.center_left {
    flex: 1;
}
/* 右边 */
.center_right {
    flex: 1;
    position: relative;
}
/* 已选择项 */
.clone_select_item {
    height: 44px;
    cursor: default;
    width: 100%;
    position: relative;
}
/* 已选择-图标 */
.clone_select_item_icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 16px;
    background-size: 24px;
}
/* 已选择-文字 */
.clone_select_item_name {
    font-size: 14px;
    color: #2E2F33;
    font-weight: 500;
    height: 44px;
    line-height: 44px;
    display: inline-block;
    width: calc(100% - 50px);
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
/* 已选择-删除 */
.clone_select_item_delete {
    height: 44px;
    width: 200%;
    text-align: right;
    box-sizing: border-box;
    background: rgba(0, 106, 255, 0.05);
    position: absolute;
    z-index: 1;
    top: 0px;
    display: none;
}
.clone_select_item:hover>.clone_select_item_delete {
    display: block;
}
.center_right .clone_select_item_delete {
    left: -100%;
}
.clone_select_item_delete>.clone_delete {
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-position: center;
    display: inline-block;
    margin-top: 10px;
    margin-right: 10px;
    cursor: pointer;
}
/* 网站框 */
.website_item_box:hover {
    background: rgba(0, 106, 255, 0.05);
    cursor: pointer;
}
/* 网站-状态 */
.website_item_status {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 14px;
    margin-right: 10px;
}
/* 网站-图标 */
.website_item_icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
    background-size: 24px;
}
/* 网站-名称 */
.website_item_name {
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    font-weight: 500;
    color: #2E2F33;
    display: inline-block;
    width: calc(100% - 80px);
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
/* 网站-单个子元素（站点或数据库） */
.website_item_child:hover {
    background: rgba(0, 106, 255, 0.05);
    cursor: pointer;
}
/* 子元素缩进 */
.website_item_child>.website_item_status {
    margin-left: 48px;
}
/* 子元素名称宽度 */
.website_item_child>.website_item_name {
    width: calc(100% - 114px);
}
/* 加载中 */
.lite-website-loading {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
/* 简洁圆环旋转动画 */
.lite-website-loading::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 4px solid #DCE4F5;
    border-top-color: #5562B4;
    border-radius: 50%;
    animation: spin_website 0.8s linear infinite;
}
@keyframes spin_website {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_website_restore_select.vue